import {
  fixFeatureButton,
  removeDoubleSearchFocus,
  createCustomToggle,
  modifySignup,
} from '../js/helpers';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  modifySignup();
  createMapButton();
  fixFeatureButton();
  removeDoubleSearchFocus();
  createCustomToggle();
});

$(globalThis).load(function () {
  setTimeout(customizeWeatherWidget, 1500);
});

// Adds "Directions" button to the map
function createMapButton() {
  const maphref = $('.standAloneDirections');
  maphref.addClass('button');
  maphref.text('Directions');

  $('.address-map .directions-button').append(maphref);
}

// Displays only the temperature in the weather widget
function customizeWeatherWidget() {
  const str = $('#weatherBugDescription').text();
  $('#weatherBugWidget').addClass('weatherBugSet');
  const findSpace = str.lastIndexOf(' ');
  const stringLength = str.length;
  const res = str.substring(findSpace, stringLength);
  const start = str.substring(0, findSpace);
  $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
}
